// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"628426d46b176a4f","3327":"4d11f6c8f580b59f","5405":"4d11f6c8f580b59f","5645":"bebc1c1538f62d68"}[chunkId] + ".css";
};